<div
  class="w-full rounded-2xl mb-7"
  [style.height.px]="height()"
  [style.padding]="padding()"
  [style.background-color]="backgroundColor()"
>
  @if (breadcrumbs()?.length) {
    <app-breadcrumb [items]="breadcrumbs()!" />
  }

  <div class="flex justify-between items-center">
    <h2 [style.height.px]="headerHeight()" [style.lineHeight.px]="headerHeight()">{{ header() }}</h2>

    @if (addButtonConfiguration()) {
      <app-create-entity-button
        [labelKey]="addButtonConfiguration()!.labelKey"
        [redirectUrl]="addButtonConfiguration()!.redirectUrl"
        [permissions]="addButtonConfiguration()!.permissions"
        [onClick]="addButtonConfiguration()!.onClick"
      />
    }
  </div>

  <ng-content />
</div>
